import React, { useEffect, useState } from 'react';
import { WP_SITE_URL, WP_API, POSTS_PER_PAGE } from '../constants/constants.js'
import Podcast from './Podcast.js'

function TemplatePodcast() {
    const [podcasts, setPodcasts] = useState([]);
    const [error, setError] = useState(false) // déclare une variable d'état "error" qui est initialement définie comme false, "setError" est la fonction utilisée pour mettre à jour cette variable d'état.


    async function fetchImageURL(podcast) {
        try {
            const response = await fetch(`${WP_SITE_URL}${WP_API}media/${podcast.acf.programme_visuel}`);
            const media = await response.json();
            const podcast_visuel_url = media.source_url;
            podcast.acf = { ...podcast.acf, podcast_visuel_url }
            return { ...podcast };
        } catch (error) {
            console.error(error);
            return podcast;
        } 
    }
 
    async function fetchPodcasts() {
        try {
            console.log(`get url ${WP_SITE_URL}${WP_API}programme `);
            const response = await fetch(WP_SITE_URL + WP_API + 'programme')

            const data = await response.json();
            console.log(data);
            //const podcastsWithImageURLs = await Promise.all(data.map(fetchImageURL));
            //console.log(podcastsWithImageURLs)
            setPodcasts(data)
        } catch (error) { 
            console.error(error);
            setError(true)
        }
    }
    useEffect(()=>{
        // Effectue une action lorsqu'une dépendance (dans ce cas, 'id') change
        fetchPodcasts();
    },[])


    if (error) {
        // affiche en cas d'erreur 
        return <span>Oups il y a eu un problème</span>
    } else {
        if (Object.keys(podcasts).length > 0) { // protege l'appel a Page si pageData est vide 
            return (
                <Podcast podcasts={podcasts}  />
            );
        }

    }


}

export default TemplatePodcast

